// The texts of the form renderer: error codes (the same stable codes the server and FormHelper return), the built-in
// labels and the month names. A site overrides any of them with the `messages` option of useFormRenderer.
// A code arrives as `code` or `code||detail` (the server's form: `too_long||500`, `file_type_not_allowed||jpg,pdf`).

export const MESSAGES = Object.freeze({
    fa: {
        errors: {
            required: "این فیلد الزامی است.",
            invalid_type: "مقدار واردشده درست نیست.",
            invalid_option: "گزینه انتخاب‌شده معتبر نیست.",
            too_many_selected: "تعداد گزینه‌های انتخابی بیشتر از حد مجاز است.",
            too_long: "حداکثر {detail} کاراکتر مجاز است.",
            pattern_mismatch: "قالب مقدار واردشده درست نیست.",
            invalid_number: "یک عدد معتبر وارد کنید.",
            not_integer: "یک عدد صحیح وارد کنید.",
            above_max: "عدد باید حداکثر {detail} باشد.",
            below_min: "عدد باید حداقل {detail} باشد.",
            invalid_price: "یک مبلغ معتبر وارد کنید.",
            invalid_date: "تاریخ واردشده معتبر نیست.",
            invalid_mobile: "شماره موبایل معتبر نیست.",
            invalid_email: "ایمیل معتبر نیست.",
            invalid_national_code: "کد ملی معتبر نیست.",
            invalid_postal_code: "کد پستی معتبر نیست.",
            invalid_state: "استان معتبر نیست.",
            invalid_city: "شهر معتبر نیست.",
            city_state_mismatch: "این شهر در استان انتخاب‌شده نیست.",
            invalid_custom_value: "مقدار واردشده معتبر نیست.",
            // the codes of IRANIAN_FIELD_RULES (site_helpers.js), for a site's own card / IBAN / Instagram fields
            invalid_card_number: "شماره کارت صحیح نیست.",
            invalid_sheba_number: "شماره شبا معتبر نیست؛ ۲۴ رقم آن را دقیقا مطابق شبای حساب وارد کنید.",
            sheba_length: "شماره شبا باید ۲۴ رقم باشد (بدون IR).",
            invalid_instagram_id: "آیدی اینستاگرام صحیح نیست.",
            validation_failed: "مقدار واردشده با قانون این فیلد نمی‌خواند.",
            file_invalid: "فایل معتبر نیست.",
            file_type_not_allowed: "نوع فایل مجاز نیست. فرمت‌های مجاز: {detail}",
            file_too_large: "حجم فایل بیشتر از حد مجاز ({detail}) است.",
            file_upload_failed: "بارگذاری فایل انجام نشد. دوباره تلاش کنید.",
            file_read_failed: "خواندن فایل انجام نشد. دوباره تلاش کنید.",
            // files sent before the answer (upload_files)
            file_content_mismatch: "محتوای فایل با پسوند آن یکی نیست.",
            too_many_files: "تعداد فایل‌ها بیشتر از حد مجاز است.",
            no_files: "فایلی برای ارسال نیست.",
            invalid_values: "اطلاعات فرم معتبر نیست.",
            values_too_large: "حجم اطلاعات فرم بیشتر از حد مجاز است.",
            login_required: "برای ثبت این فرم باید وارد حساب کاربری شوید.",
            captcha_error: "تأیید امنیتی انجام نشد. دوباره تلاش کنید.",
            too_many_submissions: "تعداد تلاش‌ها زیاد است. {detail} ثانیه دیگر دوباره تلاش کنید.",
            version_conflict: "ساختار فرم تغییر کرده است. صفحه را دوباره بارگذاری کنید.",
            not_found: "این فرم پیدا نشد.",
            unknown: "ثبت فرم انجام نشد. دوباره تلاش کنید.",
            network: "ارتباط با سرور برقرار نشد. دوباره تلاش کنید.",
            review_locked: "این پاسخ در حال بررسی است و دیگر قابل ویرایش نیست.",
        },
        labels: {
            submit: "ثبت",
            submitting: "در حال ارسال…",
            add_instance: "افزودن",
            remove_instance: "حذف",
            instance: "{title} ({number})",
            choose: "انتخاب کنید",
            choose_file: "انتخاب فایل",
            remove_file: "حذف فایل",
            year: "سال",
            month: "ماه",
            day: "روز",
            success: "فرم با موفقیت ثبت شد.",
            another: "ثبت پاسخ دیگر",
            login_notice: "برای ثبت این فرم باید وارد حساب کاربری شوید.",
            required_mark: "(الزامی)",
            loading: "در حال بارگذاری فرم…",
        },
        months: {
            jalali: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
            gregorian: ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"],
        },
    },
    en: {
        errors: {
            required: "This field is required.",
            invalid_type: "This value is not valid.",
            invalid_option: "The selected option is not valid.",
            too_many_selected: "Too many options are selected.",
            too_long: "At most {detail} characters are allowed.",
            pattern_mismatch: "This value does not match the expected format.",
            invalid_number: "Enter a valid number.",
            not_integer: "Enter a whole number.",
            above_max: "The number must be at most {detail}.",
            below_min: "The number must be at least {detail}.",
            invalid_price: "Enter a valid amount.",
            invalid_date: "This date is not valid.",
            invalid_mobile: "This mobile number is not valid.",
            invalid_email: "This email address is not valid.",
            invalid_national_code: "This national code is not valid.",
            invalid_postal_code: "This postal code is not valid.",
            invalid_state: "This state is not valid.",
            invalid_city: "This city is not valid.",
            city_state_mismatch: "This city is not in the selected state.",
            invalid_custom_value: "This value is not valid.",
            invalid_card_number: "This card number is not valid.",
            invalid_sheba_number: "This IBAN is not valid; check its 24 digits against your account's IBAN.",
            sheba_length: "An IBAN has 24 digits (without IR).",
            invalid_instagram_id: "This Instagram id is not valid.",
            validation_failed: "This value does not meet the rule of this field.",
            file_invalid: "This file is not valid.",
            file_type_not_allowed: "This file type is not allowed. Allowed: {detail}",
            file_too_large: "The file is larger than the limit ({detail}).",
            file_upload_failed: "The file could not be uploaded. Try again.",
            file_read_failed: "The file could not be read. Try again.",
            // files sent before the answer (upload_files)
            file_content_mismatch: "The file's content does not match its extension.",
            too_many_files: "Too many files.",
            no_files: "There is no file to send.",
            invalid_values: "The form data is not valid.",
            values_too_large: "The form data is too large.",
            login_required: "You need to sign in to submit this form.",
            captcha_error: "The security check failed. Try again.",
            too_many_submissions: "Too many attempts. Try again in {detail} seconds.",
            version_conflict: "The form has changed. Reload the page.",
            not_found: "This form was not found.",
            unknown: "The form could not be submitted. Try again.",
            network: "Could not reach the server. Try again.",
            review_locked: "This answer is being reviewed and cannot be edited any more.",
        },
        labels: {
            submit: "Submit",
            submitting: "Sending…",
            add_instance: "Add",
            remove_instance: "Remove",
            instance: "{title} ({number})",
            choose: "Choose",
            choose_file: "Choose a file",
            remove_file: "Remove file",
            year: "Year",
            month: "Month",
            day: "Day",
            success: "The form was submitted.",
            another: "Send another response",
            login_notice: "You need to sign in to submit this form.",
            required_mark: "(required)",
            loading: "Loading the form…",
        },
        months: {
            jalali: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Dey", "Bahman", "Esfand"],
            gregorian: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        },
    },
});

export const lang_of = (lang) => (lang === "en" ? "en" : "fa");

const fill = (text, values) => String(text).replace(/\{(\w+)\}/g, (match, name) => (values[name] === undefined ? "" : String(values[name])));

// `overrides`: { errors: { code: text }, labels: { name: text } } from the site, per language or flat
const table_of = (lang, group, overrides) => {
    const own = overrides?.[lang_of(lang)]?.[group] || overrides?.[group] || {};
    return { ...MESSAGES[lang_of(lang)][group], ...own };
};

export const split_code = (raw) => {
    const text = String(raw ?? "");
    const at = text.indexOf("||");
    return at < 0 ? { code: text, detail: undefined } : { code: text.slice(0, at), detail: text.slice(at + 2) };
};

const format_bytes = (value) => {
    const bytes = Number(value);
    if (!Number.isFinite(bytes)) {
        return String(value);
    }
    return bytes >= 1024 * 1024 ? `${Math.round((bytes / (1024 * 1024)) * 10) / 10} MB` : `${Math.round(bytes / 1024)} KB`;
};

// "required" | "too_long||500" -> a readable sentence; an unknown code falls back to the generic text, never to the code
export const error_message = (raw, lang, overrides) => {
    const { code, detail } = split_code(raw);
    const table = table_of(lang, "errors", overrides);
    const template = table[code] || table.unknown;
    const shown = code === "file_too_large" ? format_bytes(detail) : (detail ? detail.split(",").join(", ") : "");
    return fill(template, { detail: shown });
};

export const label_of = (name, lang, overrides, values = {}) => fill(table_of(lang, "labels", overrides)[name] ?? name, values);

export const month_names = (calendar, lang) => MESSAGES[lang_of(lang)].months[calendar === "jalali" ? "jalali" : "gregorian"];

// a server/client error map entry (a list of raw codes) -> one text
export const first_error_text = (codes, lang, overrides) => (Array.isArray(codes) && codes.length > 0 ? error_message(codes[0], lang, overrides) : "");
